import React from 'react';

interface StatusNotificationProps {
  title: string;
  message: string;
}

const StatusNotification: React.FC<StatusNotificationProps> = ({
  title,
  message,
}) => {
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-amber-100 text-amber-600">
          <svg
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v4m0 4h.01M10.29 3.86l-7.4 12.8a1 1 0 00.86 1.5h14.5a1 1 0 00.86-1.5l-7.4-12.8a1 1 0 00-1.72 0z"
            />
          </svg>
        </span>
        <div>
          <p className="text-sm font-semibold ">{title}</p>
          <p className="text-xs">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default StatusNotification;
